export const user = {
    /**
    * Gets the programmatic name of the entire locale, with the language,
    *   country and variant separated by underbars. The Language is always lower case,
    *   and country is always upper case. If the language is missing,
    *   the string will begin with an underscore character.
    *   If both the language and country fields are missing,
    *   this function will return the empty string,
    *   even if the variant field is filled in (you cannot have a locale with just a variant--
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        user:'user',
        user_id:'User ID',
        user_name:'Username',
        add_user:'Add user',
        user_information:'user Information',
        site:'Site',
        select_site:'Select Site',
        zone:'Zone',
        select_zone:'Select Zone',
        first_name:'First Name',
        middle_name:'Middle Name',
        last_name:'Last Name',
        email_id:'Email ID',
        phone:'Phone',
        is_active:'Is active',
        edit_user:'Edit user',
        cancel:'cancel',
        user_onboarding:'User Onboarding',
        site_id:'site ID',
        site_name:'site Name',
        role:'Role',
        action:'Action',
        select_role:'Select Role',
        activate:'activate',
        enter_first_name:'Enter First Name',
        enter_middle_name:'Enter Middle Name',
        enter_last_name:'Enter Last Name',
        enter_mail_id:'Enter E-Mail ID',
        enter_phone:'Enter Phone Number',
        mobile: 'Mobile',
        submit:'submit',
        user_status:'User Status',
        mobile_number:'Mobile Number',
        phone_number:'Phone Number',
        field_engineer: 'Field Engineer Name',
        user_name_space: 'User Name',
        is_tcl_user: 'Is TCL User',
        is_field_engineer:'Is Field Engineer',
        location:'Location',
        status:'Status',
        new_password:'New Password',
        confirm_password:'Confirm Password',
        current_password:"Current Password",
        change_password:"Change Password",
        user_configuration:"User Configuration",
        delete_confrim_msg:"Are you sure you want to delete this user?",
        password_change:{
            success:'Password updated successfully',
			error:'Unable to update password. Please try again'
        },
        profile:{
            get:{
                error: 'Unable to find the data. Please try again'
            },
            update:{
                success:'Profile updated successfully.',
                error:'Unalbe to update the profile. Please try again.'
            }
        },
    },

    ar: {
        user:'المستخدم',
        user_id:'معرف المستخدم',
        user_name:'اسم المستخدم',
        add_user:'إضافة مستخدم',
        user_information:'معلومات المستخدم',
        site:'الموقع',
        select_site:'حدد الموقع',
        zone:'المنطقة',
        select_zone:'حدد المنطقة',
        first_name:'الاسم الأول',
        middle_name:'الاسم الأوسط',
        last_name:'الكنية',
        email_id:'الايميل',
        phone:'الهاتف',
        is_active:'نشط',
        edit_user:'تحرير العضو',
        cancel:'إلغاء',
        user_onboarding:'إعداد المستخدم',
        site_id:'معرف الموقع',
        site_name:'اسم الموقع',
        role:'الدور',
        action:'الوظيفة',
        select_role:'حدد الدور',
        activate:'تفعيل',
        enter_first_name:'أدخل الاسم الأول',
        enter_middle_name:'أدخل الاسم الأوسط',
        enter_last_name:'إدخال اسم آخر',
        enter_mail_id:'أدخل معرف البريد الإلكتروني',
        enter_phone:'أدخل رقم الهاتف',
        mobile: 'التليفون المحمول',
        submit:'إرسال',
        user_status:'حالة المستخدم',
        mobile_number:'رقم الهاتف المحمول',
        phone_number:'رقم الهاتف',
        field_engineer: 'اسم المهندس الميداني',
        user_name_space: 'اسم االمستخدم',
        is_tcl_user: 'هل مستخدم TCL',
        is_field_engineer:'مهندس ميداني',
        location:'الموقع',
        status:'الحالة',
        new_password:'كلمة السر الجديدة',
        confirm_password:'تأكيد كلمة المرور',
        current_password:"كلمة السر الحالية",
        change_password:"تغيير كلمة المرور",
        user_configuration:"تكوين المستخدم",
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا المستخدم؟",
        password_change:{
            success:'تم تحديث كلمة السر بنجاح',
			error:'تعذر تحديث كلمة المرور. حاول مرة اخرى'
        },
        profile:{
            get:{
                error: 'تعذر العثور على البيانات. حاول مرة اخرى'
            },
            update:{
                success:'تم تحديث الملف الشخصي بنجاح.',
                error:'تعذر تحديث ملف التعريف. حاول مرة اخرى.'
            }
        },
    }
}
